module.exports = __webpack_public_path__ + "static/media/like.af17153e.svg";